import { Button } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CompleteImage } from '@/assets/imgs/guide/complete.svg'
import { useSelector } from '@/store'
import { neverRemindApi } from '@/services/api'
import { REF_OBJECT } from '@/constants'
import { GuideModal } from '../GuideModal'
import styles from './index.module.less'

export const CompleteGuideModal: React.FC = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const { taskDetailResBos } = useSelector((state) => state.common.guideInfo || REF_OBJECT)

  useEffect(() => {
    if (taskDetailResBos?.length && taskDetailResBos?.every((i) => i.completeStatus)) {
      setVisible(true)
    }
  }, [taskDetailResBos])

  const handleComplete = async () => {
    await neverRemindApi()
    setVisible(false)
  }

  return (
    <GuideModal banner={<CompleteImage />} visible={visible}>
      <h3 className={styles.caption}>{t('dashbord.guide.finishAll')}</h3>
      <p className={styles.content} dangerouslySetInnerHTML={{ __html: t('dashbord.guide.touchUsDanger') }} />
      <p className={styles.content}>{t('dashbord.guide.thanksTips')}</p>
      <div className={styles.btnBar}>
        <Button onClick={handleComplete} color="primary">
          {t('auth.area.noAuth.okText')}
        </Button>
      </div>
    </GuideModal>
  )
}

CompleteGuideModal.displayName = 'CompleteGuideModal'
